import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ExcelService } from '@lmc-app/services/excel.service';
import { MatIcon } from '@angular/material/icon';

@Component({
	selector: 'app-custom-export-excel',
	templateUrl: './custom-export-excel.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./custom-export-excel.component.scss'],
	imports: [MatIcon],
})
export class CustomExportExcelComponent {
	@Input() sheetArray?: any;
	@Input() fileName?: any;

	constructor(private excelService: ExcelService) {}

	exportAsXLSX() {
		this.excelService?.exportToExcel(this.sheetArray, this.fileName);
	}
}
